<template>
	<div class="component-sub-frame-page">
		<SmartDisplayC v-if="isMobile || isSurfTmpl" :compId="moduleId" :mode="displayType" />
		<div v-else class="pc-module-main">
			<ContentPad>
				<SmartDisplayC :compId="moduleId" :mode="displayType" />
			</ContentPad>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ComponentFrameSub'
};
</script>
<script setup>
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import { useStore } from '@/utils/vue-api';
import { getCurrentInstance, computed } from 'vue';
import { useCommonData } from '@/hooks';

const vm = getCurrentInstance();
const store = useStore();
const isMobile = computed(() => store.getters.isMobileMode);
const { isSurfTmpl } = useCommonData();

const moduleId = computed(() => vm.proxy.$route.params.moduleId);
const displayType = computed(() => {
	const subPath = vm.proxy.$route.params.subPath;
	if (subPath === 'detail') {
		return isMobile.value ? 'mob-detail' : 'detail';
	}
	return subPath;
});
</script>

<style lang="less" scoped>
.pc-module-main {
	padding-top: 32px;
	padding-bottom: 67px;
}
</style>
